import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'loading',
  templateUrl: './loading.html',
  standalone: false,
})
export class LoadingComponent implements AfterViewInit {
  @ViewChild('svg', { static: false }) svgElement: ElementRef;
  color: string;
  @Input('scale') scaleValue: number = 0.9;
  @Input('margin') margin: string = '0';
  @Input() size: number = 40;
  @Input() strokeWidth: number = 3.2;
  @Input()
  set stroke(color: string) {
    this.color = color;
  }

  get center(): number {
    return this.size / 2;
  }

  get radius(): number {
    return this.size * 0.375;
  }

  ngAfterViewInit(): void {
    this.svgElement.nativeElement.style.stroke = this.color;
    this.svgElement.nativeElement.style.strokeWidth = this.strokeWidth.toString();
  }
}
